import { useTranslation } from "react-i18next";
import React from "react";
import { Link as RouterLink } from "react-router-dom";
import { useAuth } from "./AuthContext";
import { REPORTS } from "./reports/ReportRegistry";

// Import MUI components for a cleaner layout
import {
  Box,
  Typography,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Paper,
} from "@mui/material";
import AssessmentIcon from "@mui/icons-material/Assessment";

function Reports() {
  const { userRole } = useAuth();
  const { t } = useTranslation();

  // Your existing logic to filter and group reports is correct
  const visibleReports = REPORTS.filter((r) => r.roles.includes(userRole));
  const reportsByCategory = visibleReports.reduce((acc, r) => {
    const categoryName = t(r.categoryKey);
    acc[categoryName] = acc[categoryName] || [];
    acc[categoryName].push(r);
    return acc;
  }, {});

  return (
    <Box>
      <Typography variant="h4" component="h1" gutterBottom>
        {t("reports.title")}
      </Typography>
      <Typography variant="body1" color="text.secondary" paragraph>
        {t("reports.selectReport")}
      </Typography>

      {Object.keys(reportsByCategory).length > 0 ? (
        Object.keys(reportsByCategory).map((category) => (
          <Box key={category} sx={{ mb: 4 }}>
            <Typography variant="h5" component="h2" gutterBottom>
              {category}
            </Typography>
            <Paper>
              <List sx={{ py: 0 }}>
                {reportsByCategory[category].map((report) => (
                  <ListItem key={report.slug} disablePadding>
                    <ListItemButton component={RouterLink} to={report.path}>
                      <ListItemIcon>
                        <AssessmentIcon />
                      </ListItemIcon>
                      <ListItemText primary={t(report.titleKey)} />
                    </ListItemButton>
                  </ListItem>
                ))}
              </List>
            </Paper>
          </Box>
        ))
      ) : (
        <Typography sx={{ mt: 4 }}>
          {t("reports.noReportsAvailable")}
        </Typography>
      )}
    </Box>
  );
}

export default Reports;
